import React from 'react';

export const LoaderRingSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 320 320" {...props}>
    <circle
      cx="160"
      cy="160"
      r="140"
      fill="none"
      stroke="rgba(42,153,183,0.16)"
      strokeWidth="1.5"
    />
    <g className="logo-loader-ring-g">
      <circle
        cx="160"
        cy="160"
        r="140"
        fill="none"
        stroke="#2A99B7"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="180 700"
      />
      <circle cx="300" cy="160" r="4" fill="#F54900" />
    </g>
  </svg>
);

export default LoaderRingSvg;
